export default __webpack_public_path__ + "static/media/x-red.3b46ebf1.svg";